import { Text } from '@chakra-ui/react';
import * as React from 'react';

export const MemberDirectoryResultsCount: React.FC<{
  totalCount: number;
}> = ({ totalCount }) => {
  return (
    <Text color="gray.700">
      Showing {totalCount.toLocaleString()} Result{totalCount === 1 ? '' : 's'}
    </Text>
  );
};
